import { Destructable, Subscription } from "./types";
import DestructorMap from "./DestructorMap";

export default class SubscriptionMap extends DestructorMap<Destructable, Subscription> {
	delete(key: Destructable): boolean {
		this.get(key)?.unsubscribe();
		return super.delete(key);
	}

	clear(): void {
		for (const subscription of this.values()) {
			subscription.unsubscribe();
		}
		super.clear();
	}

	destroy() {
		for (const subscription of this.values()) {
			subscription.unsubscribe();
		}
		super.destroy();
	}
}
